import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

const TermsPage = () => (
  <div className="container grid-xl">
  <Helmet title="Terms" />
    <section className="terms section">
   <div className="columns">
  <div className="column col-8 col-md-12">
  <h3 className="red">ご利用規約</h3>
  <br/>
  <p>ご利用にあたってのお願い</p>
  <p>このホームページをご利用頂きます前に、下記のご利用条件をよくお読みいただき、ご同意の上ご利用お願い申し上げます。ご利用頂きました場合には、下記の諸条件すべてにご同意頂いたものとさせて頂きます。</p>
  <p>ご利用条件</p>
  <p className="red">1.著作権について</p>
  <p>このホームページ上のすべての著作物、肖像、キャラクター、マーク、その他の情報は、当社ないしその提供者が著作権等の知的財産権、又はその使用権その他の権利を有しております。このホームページのダウンロード、プリントアウトその他の方法・手段による複製は、個人的又は家庭内での限られた範囲における私的使用に限るものとさせて頂きます。このホームページ内の情報やプログラムを、他のホームページや印刷物に転用（コピー、アップロード、掲載、引用など）することはできません。</p>
  <p className="red">2.商標について</p><p>このホームページに表示されている商標に関する権利は、当社、または生産元醸造所がその使用を認めた権利者に帰属します。権利者に無断で使用することはできません。</p>
  <p className="red">3.リンクの取扱について</p>
  <p>希望される方は、当社国際部輸入ビール企画（<a href="mailto:beer@konishi.jp">beer[at]konishi.jp</a>）までお申し出下さい。検討後、ご連絡を差し上げます。</p><p className="red">4.メールについて</p><p>お客様から頂いたお問合せ等について、当社からメールにてお返事を差し上げる場合や、お客様に同意を頂いた上で当社から様々な情報をメールにてお知らせする場合があります。これらのメールについての著作権は当社に帰属しており、当社に無断で他のホームページや印刷物などへ転用することはできません。</p><p className="red">5．ホームページ提供の一時中断</p><p>当社は、システムの保守・障害、火災・停電、地震等の天災、その他運用・技術上このホームページ提供の一時中断が必要であると判断した場合には、事前に通知することなしに一時中断措置をとることがあります。この中断により生じた損害については、一切責任を負いません。</p><p className="red">6.ホームページの変更</p><p>当社は、事前に通知することなく、このホームページの内容を変更することがありますので、予めご了承下さい。</p><p className="red">7.免責事項について</p><p>当社は、このホームページで提供する情報、プログラム、各種サービス、その他ホームページに関するすべての事項について、その完全性、正確性、有用性等につき、いかなる保証も致しません。また、当社は、このホームページのご利用に起因するソフトウェア、ハードウェア上の事故、ご利用者間又はご利用者と第三者の間において生じたトラブル、その他の事故等による損害のすべてについて、いかなる責任も負いません。</p><p className="red">8.個人情報の保護について</p><p>当社は、お客様からご提供頂いた個人情報を尊重し、個人情報の保護に努めております。詳しくは「<Link to="privacy" className="red">個人情報の保護に関する基本方針</Link>」をご覧ください。</p>
  </div></div>
  
    </section>
  </div>
)

export default TermsPage



// WEBPACK FOOTER //
// ./src/pages/terms.js